import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import { useDispatch, useSelector } from 'react-redux';
import { Row, Col, FormGroup } from 'react-bootstrap';
import { useParams, Link, useHistory } from 'react-router-dom';

import { useTranslation } from 'react-i18next';
import * as bomLibAction from '../../../Library/BomLibrary/store/BomLibrary.action';
import * as systemMasterAction from '../../../SystemMasters/Store/SystemMasters.action';
import { customStyles, transportArray, QualityArray, createOptions } from '../../../../Components/helper';
import Compositions from './Composition';
import * as supplierToDo from './store/SupplierToDo.action';
import CustomButtonPopup from '../../../../Components/ModalPopup/CustomButtonPopup';
import Loader from '../../../../Components/Utility/Loader/Loader';

function EditSupplierToDo() {
  const { toDoId, devOrderId } = useParams();
  const history = useHistory();
  const reducer = useSelector((reducerstate) => reducerstate);
  const {
    UserDetails: { userInfo },

    SystemMastersDetails: { finalList, BOMTypeList },
    BomLibraryDetails: { UnitOfMeasure, Composition },
    SupplierTodoModule: { toDoDetailData, componentSubType },
  } = reducer;

  const highlightedFieldCustomReactSelect = 'highlighted-field custom-react-select';
  const highlightedFieldClass = 'highlighted-field d-flex';

  const highlightedField = 'highlighted-field';
  const keysApproved = 'key-to-check-field';
  const keysApprovedFieldCustomReactSelect = 'key-to-check-field custom-react-select';
  const keysApprovedFieldClass = 'key-to-check-field d-flex';
  const dispatch = useDispatch();
  const { t } = useTranslation('common');

  const [toDoData, setToDOData] = useState();
  const [originalData, setOriginalData] = useState();
  const [highlightedKey, setHighlightedKey] = useState([]);
  const [bomTypeName, setBomTypeName] = useState(null);
  const [compositionErrors, setCompositionErrors] = useState({});
  const [showPopup, setShowPopup] = useState(false); // For the popup
  const [isLoading, setIsLoading] = useState(false);

  const getHighlightedFieldCustomReact = (item) => {
    return highlightedKey?.includes(item) ? highlightedFieldCustomReactSelect : 'custom-react-select';
  };

  const getHighlightedFieldClass = (item) => {
    return highlightedKey?.includes(item) ? highlightedFieldClass : 'd-flex';
  };

  useEffect(() => {
    setToDOData(toDoDetailData);
    setOriginalData(toDoDetailData);
    setHighlightedKey(toDoDetailData?.bomFields);

    const name = BOMTypeList?.filter((data) => {
      return data._id === toDoDetailData?.bomType;
    });
    setBomTypeName(name?.[0]?.name);
  }, [toDoDetailData, BOMTypeList]);

  useEffect(() => {
    async function fetchCompositionAPI() {
      dispatch(bomLibAction.fetchBomLibarayComposition({ loggedInUserId: userInfo?.userId, bomTypeId: toDoDetailData?.bomType }));
      dispatch(
        systemMasterAction.getPlacementDetails({
          loggedInUserId: userInfo?.userId,
          bomTypeId: toDoDetailData?.bomType,
        }),
      );
    }
    if (toDoDetailData) {
      fetchCompositionAPI();
    }
  }, [toDoDetailData]);

  const handleInputChange = (e, index, fieldName) => {
    const { value } = e.target;
    setToDOData((prev) => {
      const updatedBoms = [...prev.boms];
      updatedBoms[index] = {
        ...updatedBoms[index],
        [fieldName]: value,
      };
      return {
        ...prev,
        boms: updatedBoms,
      };
    });
  };

  const handleSelectChange = (val, index, fieldName) => {
    const value = val?._id || val?.value;
    setToDOData((prev) => {
      const updatedBoms = [...prev.boms];
      updatedBoms[index] = {
        ...updatedBoms[index],
        [fieldName]: value,
      };
      return {
        ...prev,
        boms: updatedBoms,
      };
    });
  };

  const handleCompositionErrorChange = (index, hasError) => {
    setCompositionErrors((prev) => ({
      ...prev,
      [index]: hasError,
    }));
  };

  const handleSelectChangeForOther = (val, index, fieldName) => {
    const value = val;
    setToDOData((prev) => {
      const updatedBoms = [...prev.boms];
      updatedBoms[index] = {
        ...updatedBoms[index],
        [fieldName]: value,
      };
      return {
        ...prev,
        boms: updatedBoms,
      };
    });
  };

  useEffect(() => {
    async function fetchAPI() {
      setIsLoading(true);
      const res = await dispatch(supplierToDo.getSupplierDataByDevId({ todoid: toDoId, devOrderId }));
      if (res) {
        setIsLoading(false);
      }
    }
    fetchAPI();
  }, [toDoId, devOrderId]);

  useEffect(() => {
    async function fetchAPI() {
      await Promise.all([
        dispatch(supplierToDo.getAllComponentSubTypeWithoutBomType()),
        dispatch(bomLibAction.fetchBomLibarayUnitOfMeasure({ isActive: true, loggedInUserId: userInfo?.userId })),
        dispatch(systemMasterAction.getFinalsDetails({ isActive: true })),
        dispatch(systemMasterAction.getBOMTypeDetails({ isAllRecord: true })),
      ]);
    }
    fetchAPI();
  }, []);

  const handleCompositionChange = (updatedComposition, index) => {
    setToDOData((prev) => {
      const updatedBoms = [...prev.boms];
      updatedBoms[index] = {
        ...updatedBoms[index],
        composition: updatedComposition,
      };
      return {
        ...prev,
        boms: updatedBoms,
      };
    });
  };

  const specialCase = (key) => {
    if (highlightedKey.includes('size')) {
      if (key === 'sizeUnitOfMeasure') {
        return false;
      }
    }
    if (highlightedKey.includes('weight')) {
      if (key === 'weightUnitOfMeasure') {
        return false;
      }
    }
    if (highlightedKey.includes('quantity')) {
      if (key === 'quantityUnitOfMeasure') {
        return false;
      }
    }
  };

  const detectChanges = () => {
    let returnValue = false;
    if (!toDoData || !originalData) {
      return returnValue;
    }
    if (!returnValue) {
      toDoData.boms.forEach((formItem, formIndex) => {
        const originalItem = originalData.boms[formIndex];
        const keysToCheck = [
          'BOMSupplier',
          'additionalInfo',
          'bomDescription',
          'suppliers',
          'bomSubType',
          'bomType',
          'composition',
          'referenceCode',
          'size',
          'sizeUnitOfMeasure',
          'weight',
          'weightUnitOfMeasure',
          'quantity',
          'quantityUnitOfMeasure',
          'newPlacement',
          'transport',
          'quality',
          'bomComponentSubType',
          'finished',
        ];
        for (const key of keysToCheck) {
          if (!highlightedKey.includes(key) && specialCase(key) && formItem[key] !== originalItem[key]) {
            returnValue = true;
          }
        }
      });
      return returnValue;
    }
  };

  const submitData = async () => {
    const hasErrors = Object.values(compositionErrors).some((error) => error);
    if (!hasErrors) {
      const obj = {
        todoid: toDoId,
        devOrderId,
        module: 'BOM',
        newPlacement: [],
        boms: toDoData.boms,
        bomFields: toDoData.bomFields,
        bomType: toDoData.bomType,
      };
      const res = await dispatch(supplierToDo.saveDetailConfigData(obj, t));
      if (res?.code === 200) {
        history.push('/todo-list/supplier-todo');
      }
    }
  };

  const handleSubmitData = async () => {
    const hasChanged = detectChanges();

    if (hasChanged) {
      setShowPopup(true); // Show the popup if changes are detected
    } else {
      submitData(); // Submit the data directly if no changes detected
    }
  };
  const handleToggle = () => {
    setShowPopup(false);
  };

  const getClassName = (formItem) => {
    if (formItem?.keysActuallyChanged?.includes('additionalInfo')) {
      return keysApproved;
    }

    if (highlightedKey?.includes('additionalInfo')) {
      return highlightedField;
    }

    return 'd-flex';
  };

  return (
    <>
      <div className="page-title-filter sticky">
        <div className="title-container">
          <h4 className="title">{t('SUPPLIER_TO_DO.SUGGESTION_DETAILS')}</h4>
        </div>

        <div className="search-filter">
          <button type="submit" className="btn btn-white btn-back-lib" onClick={handleSubmitData}>
            {t('SUPPLIER_TO_DO.SUBMIT')}
          </button>
          <Link className="btn btn-white btn-back-lib" to="/todo-list/supplier-todo">
            {t('SUPPLIER_SUGGESTION_FORM.BACK')}
          </Link>
        </div>
      </div>
      {isLoading && <Loader />}
      {!isLoading &&
        (toDoData?.boms?.length > 0 ? (
          <div className="container-fluid mt-4">
            <div className="supplier-to-do">
              <div className="table-responsive">
                <table className="table custom-table">
                  <thead>
                    <tr>
                      <th>{t('SUPPLIER_TO_DO.SECTION')}</th>
                      <th>{t('SUPPLIER_TO_DO.ACTION')}</th>
                      <th>{t('SUPPLIER_TO_DO.PRODUCT_REFERENCE')}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{t('SUPPLIER_TO_DO.BILL_OF_MATERIALS')}</td>
                      <td>{t('SUPPLIER_TO_DO.AMENDED')}</td>
                      <td>{toDoData?.number}</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div className="listing-card card mt-4 mb-3">
                <div className="card-header">
                  <div>
                    <ul className="card-header-icon">
                      <li>
                        <div className="cus-chk-block">{bomTypeName}</div>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="card-body">
                  {toDoData?.boms?.length > 0 &&
                    toDoData?.boms?.map((formItem, index) => (
                      <div key={formItem._id} className="d-flex justify-content-between">
                        <div className="suggestion-form mt-2 mb-3">
                          <Row>
                            <Col lg="3">
                              <FormGroup>
                                <div className="input-group form-floating-label fixed-label disabled">
                                  <input
                                    type="text"
                                    tabIndex="-1"
                                    name={`bomForm[${index}].referenceCode`}
                                    className="form-control"
                                    value={formItem.referenceCode || ''}
                                    onChange={(e) => handleInputChange(e, index, 'referenceCode')}
                                  />
                                  <label className="asterisk-req asterisk-req">
                                    {t('BOM_TYPE_FORM.REFERENCE_CODE')}
                                    <span>*</span>
                                  </label>
                                </div>
                              </FormGroup>
                            </Col>

                            <Col lg={3}>
                              <FormGroup
                                className={
                                  formItem?.keysActuallyChanged?.includes('bomDescription')
                                    ? keysApproved
                                    : highlightedKey?.includes('bomDescription') && highlightedField
                                }
                              >
                                <div className="input-group form-floating-label fixed-label">
                                  <input
                                    type="text"
                                    name={`bomForm[${index}].bomDescription`}
                                    className="form-control"
                                    value={formItem.bomDescription || ''}
                                    onChange={(e) => {
                                      handleInputChange(e, index, 'bomDescription');
                                    }}
                                    disabled={!highlightedKey?.includes('bomDescription') || formItem?.keysActuallyChanged?.includes('bomDescription')}
                                  />
                                  <label className="asterisk-req to-do-Label">{t('BOM_TYPE_FORM.COMPONENT_DESCRIPTION')}</label>
                                </div>
                              </FormGroup>
                            </Col>
                            <Col lg="3">
                              <FormGroup>
                                <div
                                  className={
                                    formItem?.keysActuallyChanged?.includes('transport')
                                      ? keysApprovedFieldCustomReactSelect
                                      : getHighlightedFieldCustomReact('transport')
                                  }
                                >
                                  <label className="field-lbl asterisk-req-green">
                                    {t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.TRANSPORT')} <span>*</span>
                                  </label>
                                  <Select
                                    name="transport"
                                    options={transportArray}
                                    getOptionLabel={(option) => `${option.label}`}
                                    getOptionValue={(option) => `${option._id}`}
                                    value={formItem?.transport}
                                    styles={customStyles}
                                    onChange={(e) => {
                                      handleSelectChangeForOther(e, index, 'transport');
                                    }}
                                    placeholder={t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.SELECT_TRANSPORT')}
                                    isClearable
                                    classNamePrefix="weight-select"
                                    className="weight-select"
                                    isDisabled={!highlightedKey?.includes('transport') || formItem?.keysActuallyChanged?.includes('transport')}
                                  />
                                </div>
                              </FormGroup>
                            </Col>
                            <Col lg="3">
                              <FormGroup>
                                <div
                                  className={
                                    formItem?.keysActuallyChanged?.includes('bomComponentSubType')
                                      ? keysApprovedFieldCustomReactSelect
                                      : getHighlightedFieldCustomReact('bomComponentSubType')
                                  }
                                >
                                  <label className="field-lbl asterisk-req-green">
                                    {t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.COMPONENT_SUB_TYPE')}
                                    <span>*</span>
                                  </label>
                                  <Select
                                    name="bomComponentSubType"
                                    options={componentSubType
                                      ?.filter((data) => data?.bomTypeId === toDoData?.bomType && data?.componentTypeId === formItem?.bomSubType)
                                      ?.map((item) => ({ label: item.name, value: item._id }))}
                                    value={createOptions(
                                      componentSubType?.filter((data) => data._id === formItem?.bomComponentSubType),
                                      'name',
                                      '_id',
                                    )}
                                    styles={customStyles}
                                    onChange={(val) => handleSelectChange(val, index, 'bomComponentSubType')}
                                    placeholder={t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.SELECT_COMPONENT_SUB_TYPE')}
                                    isClearable
                                    isDisabled={
                                      !highlightedKey?.includes('bomComponentSubType') || formItem?.keysActuallyChanged?.includes('bomComponentSubType')
                                    }
                                    classNamePrefix="weight-select"
                                    className="weight-select"
                                  />
                                </div>
                              </FormGroup>
                            </Col>

                            <Col lg={3}>
                              <FormGroup
                                className={formItem?.keysActuallyChanged?.includes('size') ? keysApprovedFieldClass : getHighlightedFieldClass('size')}
                              >
                                <div className="input-group form-floating-label fixed-label">
                                  <input
                                    type="text"
                                    name={`bomForm[${index}].size`}
                                    className="form-control"
                                    value={formItem.size || ''}
                                    onChange={(e) => handleInputChange(e, index, 'size')}
                                    disabled={!highlightedKey?.includes('size') || formItem?.keysActuallyChanged?.includes('size')}
                                  />
                                  <label className="asterisk-req"> {t('BOM_TYPE_FORM.SIZE')}</label>
                                </div>
                                <div className="inline-unit">
                                  <Select
                                    name={`bomForm[${index}].sizeUnitOfMeasure`}
                                    value={UnitOfMeasure.filter((val) => formItem.sizeUnitOfMeasure?.includes(val?._id))}
                                    onChange={(val) => handleSelectChange(val, index, 'sizeUnitOfMeasure')}
                                    options={UnitOfMeasure}
                                    getOptionLabel={(option) => `${option.name}`}
                                    getOptionValue={(option) => `${option._id}`}
                                    styles={customStyles}
                                    placeholder={t('BOM_TYPE_FORM.UOM')}
                                    classNamePrefix="weight-select"
                                    className="weight-select"
                                    isDisabled={!highlightedKey?.includes('size') || formItem?.keysActuallyChanged?.includes('size')}
                                  />
                                </div>
                              </FormGroup>
                            </Col>

                            <Col lg={3}>
                              <FormGroup
                                className={formItem?.keysActuallyChanged?.includes('weight') ? keysApprovedFieldClass : getHighlightedFieldClass('weight')}
                              >
                                <div className="input-group form-floating-label fixed-label">
                                  <input
                                    type="text"
                                    name={`bomForm[${index}].weight`}
                                    className="form-control weight-select"
                                    classNamePrefix="weight-select"
                                    value={formItem.weight || ''}
                                    onChange={(e) => handleInputChange(e, index, 'weight')}
                                    disabled={!highlightedKey?.includes('weight') || formItem?.keysActuallyChanged?.includes('weight')}
                                  />
                                  <label className="asterisk-req">{t('BOM_TYPE_FORM.WEIGHT')}</label>
                                </div>
                                <div className="inline-unit">
                                  <Select
                                    name={`bomForm[${index}].weightUnitOfMeasure`}
                                    value={UnitOfMeasure.filter((val) => formItem.weightUnitOfMeasure?.includes(val?._id))}
                                    onChange={(val) => handleSelectChange(val, index, 'weightUnitOfMeasure')}
                                    options={UnitOfMeasure}
                                    getOptionLabel={(option) => `${option.name}`}
                                    getOptionValue={(option) => `${option._id}`}
                                    styles={customStyles}
                                    classNamePrefix="weight-select"
                                    className="weight-select"
                                    placeholder={t('BOM_TYPE_FORM.UOM')}
                                    isDisabled={!highlightedKey?.includes('weight') || formItem?.keysActuallyChanged?.includes('weight')}
                                  />
                                </div>
                              </FormGroup>
                            </Col>

                            <Col lg={3}>
                              <FormGroup
                                className={formItem?.keysActuallyChanged?.includes('quantity') ? keysApprovedFieldClass : getHighlightedFieldClass('quantity')}
                              >
                                <div className="input-group form-floating-label fixed-label">
                                  <input
                                    type="text"
                                    name={`bomForm[${index}].quantity`}
                                    className="form-control"
                                    value={formItem.quantity || ''}
                                    onChange={(e) => handleInputChange(e, index, 'quantity')}
                                    disabled={!highlightedKey?.includes('quantity') || formItem?.keysActuallyChanged?.includes('quantity')}
                                  />
                                  <label className="asterisk-req">{t('BOM_TYPE_FORM.QUANTITY')}</label>
                                </div>
                                <div className="inline-unit">
                                  <Select
                                    name={`bomForm[${index}].quantityUnitOfMeasure`}
                                    value={UnitOfMeasure.filter((val) => formItem.quantityUnitOfMeasure?.includes(val?._id))}
                                    onChange={(val) => handleSelectChange(val, index, 'quantityUnitOfMeasure')}
                                    options={UnitOfMeasure}
                                    getOptionLabel={(option) => `${option?.name}`}
                                    getOptionValue={(option) => `${option?._id}`}
                                    styles={customStyles}
                                    classNamePrefix="weight-select"
                                    className="weight-select"
                                    placeholder={t('BOM_TYPE_FORM.UOMS')}
                                    isDisabled={!highlightedKey?.includes('quantity') || formItem?.keysActuallyChanged?.includes('quantity')}
                                  />
                                </div>
                              </FormGroup>
                            </Col>

                            <Col lg="3">
                              <FormGroup>
                                <div
                                  className={
                                    formItem?.keysActuallyChanged?.includes('quality')
                                      ? keysApprovedFieldCustomReactSelect
                                      : getHighlightedFieldCustomReact('quality')
                                  }
                                >
                                  <label className="field-lbl asterisk-req-green">
                                    {t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.QUALITY')} <span>*</span>
                                  </label>
                                  <Select
                                    name="quality"
                                    options={QualityArray}
                                    getOptionLabel={(option) => `${option.label}`}
                                    getOptionValue={(option) => `${option._id}`}
                                    value={formItem?.quality}
                                    styles={customStyles}
                                    onChange={(e) => {
                                      handleSelectChangeForOther(e, index, 'quality');
                                    }}
                                    classNamePrefix="weight-select"
                                    className="weight-select"
                                    placeholder={t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.SELECT_QUALITY')}
                                    isClearable
                                    isDisabled={!highlightedKey?.includes('quality') || formItem?.keysActuallyChanged?.includes('quality')}
                                  />
                                </div>
                              </FormGroup>
                            </Col>

                            <Compositions
                              compositionListObj={Composition}
                              nestIndex={index}
                              fields={formItem}
                              onCompositionChange={(updatedComposition) => handleCompositionChange(updatedComposition, index)}
                              onErrorChange={handleCompositionErrorChange}
                              highlightedKey={highlightedKey}
                            />
                            <Col lg="3">
                              <FormGroup>
                                <div
                                  className={
                                    formItem?.keysActuallyChanged?.includes('finished')
                                      ? keysApprovedFieldCustomReactSelect
                                      : getHighlightedFieldCustomReact('finished')
                                  }
                                >
                                  <label className="field-lbl asterisk-req-green">
                                    {t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.FINISH')} <span>*</span>
                                  </label>
                                  <Select
                                    options={finalList}
                                    name={`bomForm[${index}].finished`}
                                    getOptionLabel={(option) => `${option.name}`}
                                    getOptionValue={(option) => `${option._id}`}
                                    value={finalList.filter((val) => formItem.finished?.includes(val?._id))}
                                    styles={customStyles}
                                    onChange={(val) => handleSelectChange(val, index, 'finished')}
                                    placeholder={t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.SELECT_FINISH')}
                                    isClearable
                                    classNamePrefix="weight-select"
                                    className="weight-select"
                                    isDisabled={!highlightedKey?.includes('finished') || formItem?.keysActuallyChanged?.includes('finished')}
                                  />
                                </div>
                              </FormGroup>
                            </Col>
                            <Col lg={6}>
                              <FormGroup className={getClassName(formItem)}>
                                <div className="input-group form-floating-label fixed-label">
                                  <input
                                    type="text"
                                    name={`bomForm[${index}].additionalInfo`}
                                    className="form-control"
                                    value={formItem?.additionalInfo || ''}
                                    onChange={(e) => {
                                      handleInputChange(e, index, 'additionalInfo');
                                    }}
                                    disabled={!highlightedKey?.includes('additionalInfo') || formItem?.keysActuallyChanged?.includes('additionalInfo')}
                                  />
                                  <label>{t('FILTER.ADDITIONAL_INFORMATION')}</label>
                                </div>
                              </FormGroup>
                            </Col>
                          </Row>
                        </div>
                      </div>
                    ))}
                </div>
              </div>
            </div>
          </div>
        ) : (
          <Row>
            <Col md="12">
              <p className="mt-4 alert alert-info override-alert-info justify-content-center align-item-center d-flex">
                {t('SUPPLIER_TO_DO.NO_BOM_CONFIGURATION')}
              </p>
            </Col>
          </Row>
        ))}
      {showPopup && (
        <CustomButtonPopup onOpen={showPopup} title={t('SUPPLIER_TO_DO.WARNING')} message={t('SUPPLIER_TO_DO.CONFIRMATION_MESSAGE')} toggle={handleToggle} />
      )}
    </>
  );
}

export default EditSupplierToDo;
